import { provide, inject, type InjectionKey } from 'vue'

const TAISHOKUTODOKE_DEFAULT_REASON =
  'このたび、一身上の都合により誠に勝手ながら記載の退職日にて退職したく、お願い申し上げます。'

export type TaishokutodokeFormatData = {
  createDate: Date | null
  retirementDate: Date | null
  writeDate?: string
  taishokureason: string
  entrySummary: string
  resumeSummary: string
  occupation: string
  documentTitle: string
  company_name: string
  staff_department_name: string
  staff_name: string
  jobSummary: string
  experienceAndKnowledge: string
  skillsToUse: unknown[]
  jobHistories: unknown[]
  licenseHistories: unknown[]
  prMessage: string
} & Record<string, unknown>

const TAISHOKUTODOKE_FORMAT_DATA_KEY: InjectionKey<TaishokutodokeFormatData> =
  Symbol('taishokutodokeFormatData')

export function provideTaishokutodokeFormatData(
  formatData: TaishokutodokeFormatData
) {
  provide(TAISHOKUTODOKE_FORMAT_DATA_KEY, formatData)
}

export function useTaishokutodokeFormatData(): TaishokutodokeFormatData {
  const formatData = inject(TAISHOKUTODOKE_FORMAT_DATA_KEY)
  if (!formatData) {
    throw new Error(
      'useTaishokutodokeFormatData() must be used under TaishokutodokeEdit'
    )
  }
  return formatData
}

export function createEmptyTaishokutodokeFormatData(): TaishokutodokeFormatData {
  return {
    createDate: null,
    retirementDate: null,
    taishokureason: TAISHOKUTODOKE_DEFAULT_REASON,
    entrySummary: '',
    resumeSummary: '',
    occupation: 'others',
    documentTitle: '退職願',
    company_name: '',
    staff_department_name: '',
    staff_name: '',
    jobSummary: '',
    experienceAndKnowledge: '',
    skillsToUse: [],
    jobHistories: [],
    licenseHistories: [],
    prMessage: ''
  }
}
